"use client";

import { useEffect, useRef } from "react";

export const useSetInterval = (cb: () => void, time: number): void => {
  const cbRef = useRef<() => void>(() => {});

  useEffect(() => {
    cbRef.current = cb;
  }, [cb]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (cbRef.current) {
        cbRef.current();
      }
    }, time);

    return () => clearInterval(interval);
  }, [time]);
};
